module.exports = __webpack_public_path__ + "img/cc521a7f636af388d7c3883620888d1c.png";